import { render, staticRenderFns } from "./DeleteRecipientModal.vue?vue&type=template&id=25e480ad&"
import script from "./DeleteRecipientModal.vue?vue&type=script&lang=js&"
export * from "./DeleteRecipientModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports